import React, { useState, useEffect } from 'react';
import { debounce } from '../../utils/debounce';
import { smoothScrollTop } from '../../utils/scroll';

import { Button } from '../basic/Button/Button';

import './ScrollToTop.scss';
import iconArowUp from '../../styles/assets/icons/scroll_up.svg';


export function ScrollToTop() {
  const [isTop, setIsTop] = useState(true);

  const scrollToTop = () => {
    smoothScrollTop();
    setIsTop(true);
  };

  const handleScroll = debounce((event: Event) => {
    const isAtTop = window.pageYOffset === 0;
    setIsTop(isAtTop);
  });

  useEffect(() => {
    // componentDidMount :
    window.addEventListener('scroll', handleScroll);

    // componentWillUnmount
    return () => { window.removeEventListener('scroll', handleScroll) };
  }, []);

  return (
    <div className={ `ScrollToTop ${ isTop ? 'ScrollToTop--hide' : '' }` }>
      <Button icon={ iconArowUp } buttonType='neutral' doNotCompensateBorder={true} handleClick={scrollToTop} />
    </div>
  );
}
